import { ArrowUpTrayIcon } from "@/icons/outline";
import React from "react";

import { connect } from 'react-redux';

import { Actions as LEAVEACTIONS } from '../../../../store/actions/leaveActions';

const ImportLeave = ({
    showImportModal,
    hideButton
}) => {
    if (hideButton) return null
    return (
        <div
            className="btn btn-default pull-right mr-4"
            onClick={showImportModal}
        >
            <ArrowUpTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
            <div style={{ float: "left" }}>Import Leave</div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const timeAttendanceList = Object.values(state.integration?.timeAttendance || {})?.reduce((prev, curr) => {
        if (["ZK Teco", "TimeMoto"]) return prev
        prev.push(curr.name)
        return prev
    }, [])
    const hrisList = Object.values(state.integration?.hris || {})?.reduce((prev, curr) => {
        prev.push(curr.name)
        return prev
    }, [])
    return {
        hideButton: [...timeAttendanceList, ...hrisList]?.length > 0
    }
}

const mapDispatchToProps = dispatch => ({
    showImportModal: () => dispatch(LEAVEACTIONS.showImportModal(true)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportLeave)